<div class="department-page">
  <app-header-style-seven></app-header-style-seven>
  

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Foundational Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Strengthening every budding engineer through Mathematics, Physics,
            Chemistry, and English with a strong emphasis on communication,
            analytical thinking, scientific fundamentals, and multidisciplinary
            readiness.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Academic Role</span>
            <strong>{{ academicRole }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Core Areas</span>
            <strong>{{ coreAreas }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Focus</span>
            <strong>{{ focusArea }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Science &amp; Humanities, Fatima Michael College of
            Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- ABOUT -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title18.jpg"
                  alt="Department of Science and Humanities"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Academic Pillars</h3>
                <p>
                  The department supports engineering education through strong
                  foundations in core sciences and communication.
                </p>
              </div>

              <div class="info-grid">
                <article class="info-card" *ngFor="let unit of academicUnits">
                  <h3>{{ unit.title }}</h3>
                  <p>{{ unit.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- VISION & MISSION -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- INDUSTRIAL VISIT -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>{{ industrialVisitTitle }}</h3>
                <p>
                  Department of Science &amp; Humanities industrial exposure activity for first-year students.
                </p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of industrialVisitParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Visit Photos</h3>
                <p>Highlights from the industrial visit.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let photo of industrialVisitPhotos">
                  <div class="lab-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>

                  <div class="lab-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- FRESHER'S DAY -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>{{ freshersDayTitle }}</h3>
                <p>
                  Department of Science &amp; Humanities event conducted for welcoming first-year students.
                </p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of freshersDayParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Event Photos</h3>
                <p>Highlights from the Fresher’s Day celebration.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let photo of freshersDayPhotos">
                  <div class="lab-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>

                  <div class="lab-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- ASSOCIATION & CLUB ACTIVITIES -->
          <ng-container *ngSwitchCase="'tab12'">
            <section class="content-card">
              <div class="section-head">
                <h3>Association &amp; Club Activities</h3>
                <p>
                  Academic enrichment activities organized by the Department of Science &amp; Humanities.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name of the Event</th>
                      <th>Date</th>
                      <th>Resource Person</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of associationActivities">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.eventTitle }}</td>
                      <td>{{ item.eventDate }}</td>
                      <td>{{ item.resourcePerson || '-' }}</td>
                      <td>{{ item.description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Activity Photos</h3>
                <p>Highlights from association and club activities.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let photo of associationActivityPhotos">
                  <div class="lab-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>

                  <div class="lab-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- LABS -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>
                  Advanced laboratory support for Physics, Chemistry, and
                  Language development to strengthen conceptual understanding and
                  practical readiness.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let lab of labs">
                  <div class="lab-media">
                    <img [src]="lab.image" [alt]="lab.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ lab.title }}</h4>
                    <p>{{ lab.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- INDUCTION PROGRAM -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="section-head">
                <h3>{{ inductionProgramTitle }}</h3>
                <p>
                  Department of Science &amp; Humanities programme conducted for first year students.
                </p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of inductionProgramParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Programme Photos</h3>
                <p>Highlights from the Induction Programme.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let photo of inductionProgramPhotos">
                  <div class="lab-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>

                  <div class="lab-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- PERSONALITY DEVELOPMENT CAMP -->
          <ng-container *ngSwitchCase="'tab7'">
            <section class="content-card">
              <div class="section-head">
                <h3>{{ personalityDevelopmentCampTitle }}</h3>
                <p>
                  Department of Science &amp; Humanities student development programme for first year students.
                </p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of personalityDevelopmentCampParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Camp Photos</h3>
                <p>Highlights from the Personality Development Camp.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let photo of personalityDevelopmentCampPhotos">
                  <div class="lab-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>

                  <div class="lab-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- ACHIEVEMENTS -->
<ng-container *ngSwitchCase="'tab11'">
  <section class="content-card">
    <div class="section-head">
      <h3>Achievements</h3>
      <p>
        The Department of Science & Humanities takes pride in the achievements
        of its first year students in technical events, competitions, and
        academic enrichment activities.
      </p>
    </div>

    <div class="achievement-list" *ngIf="achievements.length > 0">
      <article class="achievement-card" *ngFor="let item of achievements">
        <h4>{{ item.title }}</h4>
        <p>{{ item.description }}</p>
      </article>
    </div>

    <div class="photo-grid" *ngIf="achievementPhotos.length > 0">
      <article class="photo-card" *ngFor="let photo of achievementPhotos">
        <div class="photo-image-wrap">
          <img [src]="photo.image" [alt]="photo.alt" class="photo-image" />
        </div>
        <p class="photo-caption">{{ photo.caption }}</p>
      </article>
    </div>
  </section>
</ng-container>

          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab8'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>
                  NPTEL certifications secured by faculty members of the Department of Science &amp; Humanities.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Staff Name</th>
                      <th>Designation</th>
                      <th>Course Name</th>
                      <th>Certification</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of shNptelRecords">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.staffName }}</td>
                      <td>{{ item.designation }}</td>
                      <td>{{ item.courseName }}</td>
                      <td>{{ item.certification }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- FOREIGN LANGUAGE TRAINING -->
          <ng-container *ngSwitchCase="'tab9'">
            <section class="content-card">
              <div class="section-head">
                <h3>{{ foreignLanguageTrainingTitle }}</h3>
                <p>
                  Department of Science &amp; Humanities language enrichment activity for first year students.
                </p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of foreignLanguageTrainingParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Programme Photos</h3>
                <p>Highlights from the writing workshop.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let photo of foreignLanguageTrainingPhotos">
                  <div class="lab-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>

                  <div class="lab-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- RESEARCH -->
 <ng-container *ngSwitchCase="'tab10'">
  <section class="content-card">
    <div class="section-head">
      <h3>{{ researchTitle }}</h3>
      <p>
        The Department of Science and Humanities publishes research contributions
        in reputed journals and indexed platforms.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Journal / Conference</th>
            <th>Title of the Paper</th>
            <th>Name of the Author</th>
            <th>SCI / SCOPUS / Google Scholar</th>
            <th>Date of Publication</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of researchPublications">
            <td>{{ item.sno }}</td>
            <td>{{ item.journalName }}</td>
            <td>{{ item.paperTitle }}</td>
            <td>{{ item.authorName }}</td>
            <td>{{ item.indexedIn }}</td>
            <td>{{ item.publicationDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of Department,<br />
          Department of Science &amp; Humanities,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" [href]="'mailto:' + contactEmail">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Academic Foundation</span>
        <h3>Building Strong Engineers from the First Step</h3>
        <p>
          Science and Humanities forms the academic base that strengthens
          technical learning, communication, and problem-solving ability across
          all engineering disciplines.
        </p>
        <a
          routerLink="/inquiry"
          class="apply-button"
        >
          Apply Now
        </a>
      </article>
    </section>
  </div>
</div>